import { axInst } from "../../Components/Login/Service.jsx";

//region
export const fetchRegion = async () => {
  const { data } = await axInst.post("/complaints/filter", {
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    origin_point: [],
    employee_name: [],
  });
  const regionsArray = data?.filter_data.REGION.buckets.map((e) => e.key);
  // .filter((e) => e !== "All Regions");
  const sortedRegionArray = regionsArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedRegionArray;
};

//state
export const fetchStates = async (pRegion) => {
  const { data } = await axInst.post("/complaints/filter", {
    region: pRegion || [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    origin_point: [],
    employee_name: [],
  });
  const statesArray = data?.filter_data.STATE.buckets.map((e) => e.key);
  const sortedStatesArray = statesArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesArray;
};

//stateoffice
export const fetchStatesOffice = async (pRegion, pState) => {
  const body = {
    region: pRegion || [],
    state: pState || [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    division_name: [],
    Product_Line: [],
    lob: [],
    origin_point: [],
    employee_name: [],
  };

  const { data } = await axInst.post("/complaints/filter", body);

  const statesOfficeArray = data?.filter_data.STATE_OFFICE.buckets.map(
    (e) => e.key
  );
  const sortedStatesOfficeArray = statesOfficeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedStatesOfficeArray;
};

//Division
export const fetchDivision = async (pRegion, pState, pStateOffice) => {
  const body = {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    division_name: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    origin_point: [],
    employee_name: [],
  };

  const { data } = await axInst.post("/complaints/filter", body);

  const DivisionArray = data?.filter_data.DIVISION_NAME.buckets.map(
    (e) => e.key
  );
  const sortedDivisionArray = DivisionArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedDivisionArray;
};

//DealerName
export const fetchDealer = async (pRegion, pState, pStateOffice, pDivision) => {
  const body = {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    division_name: pDivision || [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    origin_point: [],
    employee_name: [],
  };

  const { data } = await axInst.post("/complaints/filter", body);
  const DealerArray = data?.filter_data.DEALER_NAME.buckets.map((e) => e.key);
  const sortedDealerArray = DealerArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedDealerArray;
};

//DealerCode
export const fetchDealercode = async (
  pRegion,
  pState,
  pStateOffice,
  pDivision,
  pDealer
) => {
  const { data } = await axInst.post("/complaints/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    division_name: pDivision || [],
    dealer_name: pDealer || [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    origin_point: [],
    employee_name: [],
  });
  const dealercodeArray = data?.filter_data.DEALER_CODE.buckets.map(
    (e) => e.key
  );
  const sorteddealercodeArray = dealercodeArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sorteddealercodeArray;
};

//ProductLine
export const fetchProductLine = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision
) => {
  const { data } = await axInst.post("/complaints/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: [],
    lob: [],
    origin_point: [],
    employee_name: [],
  });
  const productLineArray = data?.filter_data.PRODUCT_LINE.buckets.map(
    (e) => e.key
  );
  const sortedProductLineArray = productLineArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedProductLineArray;
};

//Lob
export const fetchLOB = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine
) => {
  const { data } = await axInst.post("/complaints/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: [],
    origin_point: [],
    employee_name: [],
  });

  const lobArray = data?.filter_data.LOB.buckets.map((e) => e.key);
  const sortedLobArray = lobArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );

  return sortedLobArray;
};

// originpoint
export const fetchOriginPoint = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine,
  pLob
) => {
  const { data } = await axInst.post("/complaints/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    origin: [],
    employee_name: [],
  });
  const originArray = data?.filter_data.ORIGIN_POINT.buckets
    .map((e) => e.key)
    .filter((e) => e !== "");
  const sortedoriginArray = originArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedoriginArray;
};

// assigned user
export const fetchAssignedUser = async (
  pRegion,
  pState,
  pStateOffice,
  pDealer,
  pDealerCode,
  pDivision,
  pProductLine,
  pLob,
  pOriginPoint
) => {
  const { data } = await axInst.post("/complaints/filter", {
    region: pRegion || [],
    state: pState || [],
    state_office: pStateOffice || [],
    dealer_name: pDealer || [],
    dealer_code: pDealerCode || [],
    division_name: pDivision || [],
    Product_Line: pProductLine || [],
    lob: pLob || [],
    origin_point: pOriginPoint || [],
    employee_name: [],
  });
  const AssignedUserArray = data?.filter_data.EMPLOYEE_NAME.buckets
    .map((e) => e.key)
    .filter((e) => e !== "");
  const sortedAssignedUser = AssignedUserArray.sort((a, b) =>
    ("" + a).localeCompare(b, undefined, { numeric: true })
  );
  return sortedAssignedUser;
};
